import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Mail, MapPin } from 'lucide-react';
import PageLayout from '../PageLayout';
import Seo from '../Seo';
import EnquiryForm from '../EnquiryForm';
import { graph, businessSchema, breadcrumbSchema } from '../../seo/site';
import '../ServicePage.css';

const ContactPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <Seo
        path="/contact"
        jsonLd={graph([
          businessSchema(),
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Contact', path: '/contact' },
          ]),
        ])}
      />

      <PageLayout
        heroTitle="Contact Fallow Building Services"
        heroSubtitle="Get in touch for a free, no-obligation site survey"
        heroImage="/images/hero-construction.jpg"
      >
        <section className="service-benefits">
          <div className="service-container">
            <motion.div
              className="benefits-grid-modern"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div
                className="benefit-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                whileHover={{ y: -4 }}
              >
                <div className="benefit-icon-wrapper">
                  <Phone size={32} />
                </div>
                <h3 className="benefit-title">Call Us</h3>
                <p className="benefit-description">
                  <a href="tel:02035765962" className="contact-link-large">0203 576 5962</a><br />
                  Monday to Friday, 8:00am to 6:00pm
                </p>
              </motion.div>

              <motion.div
                className="benefit-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                whileHover={{ y: -4 }}
              >
                <div className="benefit-icon-wrapper whatsapp-icon">
                  <MessageCircle size={32} />
                </div>
                <h3 className="benefit-title">WhatsApp</h3>
                <p className="benefit-description">
                  <a href="https://wa.me/447459627464" target="_blank" rel="noopener noreferrer" className="contact-link-whatsapp">Message us on WhatsApp</a><br />
                  Quick responses during business hours
                </p>
              </motion.div>

              <motion.div
                className="benefit-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                whileHover={{ y: -4 }}
              >
                <div className="benefit-icon-wrapper">
                  <Mail size={32} />
                </div>
                <h3 className="benefit-title">Email</h3>
                <p className="benefit-description">
                  <a href="mailto:info@fallowbuildingservices.co.uk" className="contact-link-email">info@fallowbuildingservices.co.uk</a>
                </p>
              </motion.div>

              <motion.div
                className="benefit-card-modern"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                whileHover={{ y: -4 }}
              >
                <div className="benefit-icon-wrapper">
                  <MapPin size={32} />
                </div>
                <h3 className="benefit-title">Address</h3>
                <p className="benefit-description">
                  6 Sunningdale Road<br />
                  Rainham, Essex<br />
                  RM13 7BD
                </p>
              </motion.div>
            </motion.div>

            <motion.div
              id="enquiry-form"
              className="enquiry-form-section"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <motion.h2
                className="section-title"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.5 }}
              >
                Enquiry Form
              </motion.h2>

              <p className="form-notice">
                Prefer to talk? Call <a href="tel:02035765962" className="contact-link">0203 576 5962</a>, message us on <a href="https://wa.me/447459627464" target="_blank" rel="noopener noreferrer" className="contact-link-whatsapp">WhatsApp</a>, or email <a href="mailto:info@fallowbuildingservices.co.uk" className="contact-link-email">info@fallowbuildingservices.co.uk</a>. We aim to reply the same working day.
              </p>
              <EnquiryForm />
            </motion.div>
          </div>
        </section>
      </PageLayout>
    </>
  );
};

export default ContactPage;
